'use client';

// Utils
import { combineClasses } from '@shared/utils';

// Types
import { ResumeStep } from '@shared/types';

// Constants
import { ROUTES } from '@shared/constants';

// Icons
import { HandRaiseIcon } from '@shared/icons/HandRaiseIcon';
import { PreferencesIcon } from '@shared/icons/PreferencesIcon';
import DownloadIcon from '@shared/icons/DownloadIcon';
import EducationIcon from '@shared/icons/EducationIcon';
import FileIcon from '@shared/icons/FileIcon';
import PersonIcon from '@shared/icons/PersonIcon';
import VerificationIcon from '@shared/icons/VerificationIcon';

// Components
import SidebarItem from './SidebarItem';
import SidebarScroll from './SidebarScroll';
import PreviewSidebarItem from './PreviewSidebarItem';
import ExportSidebarItem from './ExportSidebarItem';
interface SidebarProps {
  className?: string;
}
const sidebarItemList = [{
  label: 'personal info',
  icon: <PersonIcon className="size-5" />,
  href: `.${ROUTES.PERSONAL_INFORMATION}`,
  stepKey: ResumeStep.PERSONAL_INFO
}, {
  label: 'education',
  icon: <EducationIcon className="size-5" />,
  href: `.${ROUTES.EDUCATION}`,
  stepKey: ResumeStep.EDUCATION
}, {
  label: 'skills',
  icon: <PreferencesIcon className="size-5" />,
  href: `.${ROUTES.TECHNICAL_SKILLS}`,
  stepKey: ResumeStep.SKILLS
}, {
  label: 'experiences',
  icon: <HandRaiseIcon className="size-5" />,
  href: `.${ROUTES.EXPERIENCES}`,
  stepKey: ResumeStep.WORK_EXPERIENCE
}, {
  label: 'certificates',
  icon: <VerificationIcon className="size-5" />,
  href: `.${ROUTES.CERTIFICATES}`,
  stepKey: ResumeStep.CERTIFICATIONS
}];
export const Sidebar = ({
  className
}: SidebarProps) => <nav data-testid="navbar" className={combineClasses('flex bg-white sm:bg-primary justify-center relative mb-3 sm:mb-0 px-5 sm:px-0', className)} data-sentry-component="Sidebar" data-sentry-source-file="index.tsx">
    <div className="overflow-x-auto no-scrollbar hidden sm:flex">
      {sidebarItemList.map(item => <SidebarItem key={item.href} icon={item.icon} label={item.label} href={item.href} />)}

      <div className="flex lg:absolute lg:right-0">
        <PreviewSidebarItem icon={<FileIcon className="size-5" />} label="preview" data-sentry-element="PreviewSidebarItem" data-sentry-source-file="index.tsx" />
        <ExportSidebarItem icon={<DownloadIcon className="size-5" />} label="export" data-sentry-element="ExportSidebarItem" data-sentry-source-file="index.tsx" />
      </div>
    </div>

    <SidebarScroll data-sentry-element="SidebarScroll" data-sentry-source-file="index.tsx">
      {sidebarItemList.map(item => <div key={item.href} className="flex-none snap-center">
          <SidebarItem icon={item.icon} label={item.label} href={item.href} />
        </div>)}
      <PreviewSidebarItem className="flex-none snap-center" icon={<FileIcon className="size-5" />} label="preview" data-sentry-element="PreviewSidebarItem" data-sentry-source-file="index.tsx" />
      <ExportSidebarItem className="flex-none snap-center" icon={<DownloadIcon className="size-5" />} label="export" data-sentry-element="ExportSidebarItem" data-sentry-source-file="index.tsx" />
    </SidebarScroll>
  </nav>;